import { Component, ViewChild, inject, input, output } from '@angular/core';
import { TableModule } from 'primeng/table';
import { CommonModule } from '@angular/common';
import { Paginator } from "src/app/shared/components/paginator/paginator";
import { PaginatorState } from 'primeng/paginator';
import { ButtonModule } from "primeng/button";
import { Popover, PopoverModule } from 'primeng/popover';
import { Router } from '@angular/router';
import { Routes } from 'src/app/core/routes/routes';
import { OfficeListModel } from '@features/business/models/office.model';
import { BusinessLogo } from "@shared/components/business-logo/business-logo";
import { SortHeader } from "@shared/components/sort-header/sort-header";
import { FlagImage } from "@shared/components/flag-image/flag-image";
import { UserPermission, AuthService } from '@core/auth/services/auth-service';
import { HasAnyPermissionPipe } from '@shared/pipes/has-any-permission.pipe';

interface Action {
  key: string,
  label: string
}

@Component({
  selector: 'app-offices-list',
  imports: [
    CommonModule,
    TableModule,
    Paginator,
    ButtonModule,
    PopoverModule,
    BusinessLogo,
    SortHeader,
    FlagImage,
    HasAnyPermissionPipe
],
  templateUrl: './offices-list.html',
  styleUrl: './offices-list.scss',
})
export class OfficesList {
  @ViewChild('popover') popover!: Popover;

  router = inject(Router);
  authApi = inject(AuthService);

  UserPermission = UserPermission;
  first = input<number>();
  rows = input<number>();
  data = input<OfficeListModel[]>([]);
  totalRecords = input<number>(0);
  selectedOffice: OfficeListModel | null = null;

  pageChange = output<PaginatorState>();
  handleConfirmChangeStatus = output<OfficeListModel>();

  sortBy = input<string | null>();
  sortOrder = input<string | null>();
  toggleSort = output<string>();

  actionsOptions: Action[] = [
    this.authApi.hasPermission(UserPermission.UPDATE_OFFICE) ? {key: 'edit-office', label: 'Editar sede'} : null,
    this.authApi.hasPermission(UserPermission.DELETE_OFFICE) ? {key: 'change-status', label: 'Cambiar estado'} : null,
  ].filter(option => option !== null) as Action[];

  toggle(event: Event) {
    this.popover.toggle(event);
  }

  selectOption(action: Action) {
    if (this.selectedOffice !== null) {
      switch (action.key) {
        case 'edit-office':
          this.router.navigate([Routes.officesEditPage.replace(':id', this.selectedOffice.Id)]);
          break;
        case 'change-status':
          this.handleConfirmChangeStatus.emit(this.selectedOffice);
          break;
        default:
          this.handleConfirmChangeStatus.emit(this.selectedOffice);
      }
    }
    this.popover.hide();
  }

  displayRowActions(event: MouseEvent, office: OfficeListModel) {
    if (this.selectedOffice?.Id === office.Id) {
      this.popover.hide();
      this.selectedOffice = null;
    } else {
      this.selectedOffice = office;
      this.popover.show(event);

      if (this.popover.container) {
        this.popover.align();
      }
    }
  }

  hidePopover() {
    this.popover.hide();
  }

  handleToggleSort(columnName: string) {
    this.toggleSort.emit(columnName);
  }
}
